import Vue from 'vue';
import format from 'date-fns/format';

const formatDate = (value, formatString = 'YYYY-MM-DD') =>
  value ? format(value, formatString) : '';
export default formatDate;

Vue.filter('formatDate', formatDate);
